import React, { useState, useEffect, useRef } from 'react';
import heroImage from '../images/fridge hero.jpg';
import heroImages from '../images/Fridge Cleaning.webp';
import { FaHome, FaWrench, FaSmile, FaThumbsUp } from 'react-icons/fa';
import CountUp from 'react-countup';
import singledoor from '../images/singledoor.png';
import doubledoor from '../images/doubledoor.webp';

import './FridgeService.css';

function FridgeService() {
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setInView(true);
          observer.unobserve(sectionRef.current);
        }
      },
      { threshold: 0.5 }
    );
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
//Faq Declare
  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  }

  const [showSolution, setShowSolution] = useState({});

  const toggleSolution = (id) => {
    setShowSolution((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <>
      {/* Hero Section */}
      <div className="hero-container">
        <img src={heroImage} alt="Hero" className="hero-image" />
        <div className="hero-content">
          <div className="left-section"><br/>
          <h1 className="hero-title">Welcome to Chennai Fridge Care</h1>
            <p className="hero-description">
              Reliable Fridge Repair & Maintenance Services for Your Home.
            </p>
            <button
              className="hero-button"
              onClick={() => (window.location.href = 'tel:+918270096596')}
            >
              Book Now:  82700 96596
            </button>
          </div>
        </div>
      </div>

      {/* Service Section */}
      <div className="service-section">
        <div className="service-container">
          <div className="service-image">
            <img src={heroImages} alt="Fridge Repair" />
          </div>
          <div className="service-description">
            <h2>Fridge Service</h2>
            <p>
              At <strong>Chennai Home Appliance Care</strong>, our skilled technicians provide dependable and quick fridge repair services for all major brands. Whether it's a cooling issue, electrical fault, or other problem, we're here to help. Our services include diagnosis, effective repairs, and preventive maintenance to ensure your fridge works perfectly.
            </p>
          </div>
        </div>
      </div>









      <div className="service-section">
  <div className="service-container">
    <div className="left-column">
      <h2 className="service-title">Expert Fridge Service</h2>
      <p className="service-description">
        Our expert technicians specialize in fridge repairs, maintenance, and installation. From cooling issues to thermostat repairs, we ensure your fridge runs efficiently and reliably.
      </p>
    </div>
    <div className="right-column">
      <div className="service-item">
        <div className="icon-container">
          <i className="fas fa-certificate"></i> {/* Icon for Certification */}
        </div>
        <h3 className="service-heading">Certified</h3>
        <p className="service-description">
          Our team is fully certified to provide reliable and efficient fridge repair services, ensuring the best quality and performance.
        </p>
      </div>
      <div className="service-item">
        <div className="icon-container">
          <i className="fas fa-cogs"></i> {/* Icon for Repairs */}
        </div>
        <h3 className="service-heading">Repairs</h3>
        <p className="service-description">
          From cooling issues to broken parts, our technicians handle all types of fridge repairs with precision and expertise.
        </p>
      </div>
      <div className="service-item">
        <div className="icon-container">
          <i className="fas fa-wrench"></i> {/* Icon for Maintenance */}
        </div>
        <h3 className="service-heading">Maintenance</h3>
        <p className="service-description">
          We offer routine maintenance to ensure your fridge stays in top condition, preventing costly breakdowns.
        </p>
      </div>
      <div className="service-item">
        <div className="icon-container">
          <i className="fas fa-clipboard-list"></i> {/* Icon for Inspection */}
        </div>
        <h3 className="service-heading">Inspection</h3>
        <p className="service-description">
          We conduct thorough inspections to identify any potential issues with your fridge and provide timely solutions.
        </p>
      </div>
    </div>
  </div>
</div>












      {/* Repair Issues Section */}
      <div className="repair-container">
        <h1>Common Fridge Issues & Solutions</h1>
        <div className="issues-grid">
          {/* Issue 1 */}
          <div className="issue">
            <h2>Issue 1: Fridge Not Cooling</h2>
            <p>This may be due to compressor failure or blocked vents.</p>
            <button className="solution-btn" onClick={() => toggleSolution('solution1')}>
              {showSolution['solution1'] ? 'Hide Solution' : 'View Solution'}
            </button>
            {showSolution['solution1'] && (
              <div className="solution">
                <p>Check for any obstructions in vents. If the issue persists, contact a professional technician.</p>
              </div>
            )}
          </div>

          {/* Issue 2 */}
          <div className="issue">
            <h2>Issue 2: Excessive Frost Build-up</h2>
            <p>This could be due to faulty door seals or a broken defrost timer.</p>
            <button className="solution-btn" onClick={() => toggleSolution('solution2')}>
              {showSolution['solution2'] ? 'Hide Solution' : 'View Solution'}
            </button>
            {showSolution['solution2'] && (
              <div className="solution">
                <p>Check the door seals for leaks. Replace the defrost timer if needed.</p>
              </div>
            )}
          </div>

          {/* Issue 3 */}
          <div className="issue">
            <h2>Issue 3: Water Leaks</h2>
            <p>This could be due to a blocked defrost drain or broken water inlet valve.</p>
            <button className="solution-btn" onClick={() => toggleSolution('solution3')}>
              {showSolution['solution3'] ? 'Hide Solution' : 'View Solution'}
            </button>
            {showSolution['solution3'] && (
              <div className="solution">
                <p>Clear the defrost drain and check the water inlet valve for damage.</p>
              </div>
            )}
          </div>

          {/* Issue 4 */}
          <div className="issue">
            <h2>Issue 4: Fridge is Noisy</h2>
            <p>Noises could be due to worn-out evaporator or condenser fan motors.</p>
            <button className="solution-btn" onClick={() => toggleSolution('solution4')}>
              {showSolution['solution4'] ? 'Hide Solution' : 'View Solution'}
            </button>
            {showSolution['solution4'] && (
              <div className="solution">
                <p>Inspect the fan motors and replace them if they’re worn out or damaged.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="company-service-section">
        <h2>Why Choose Chennai Home Appliance Care?</h2>
        <p>We provide reliable fridge repair services right at your doorstep. Our goal is 100% customer satisfaction through expert service and professionalism.</p>
        
        <div className="icon-grid">
          <div className="icon-card">
            <FaHome className="service-icon" />
            <h3>Home Service</h3>
            <p>Our technicians come to your home to perform all repairs.</p>
          </div>
          <div className="icon-card">
            <FaWrench className="service-icon" />
            <h3>All Fridge Models</h3>
            <p>We handle repairs for all types and brands of fridges.</p>
          </div>
          <div className="icon-card">
            <FaSmile className="service-icon" />
            <h3>100% Satisfaction</h3>
            <p>Our goal is to provide complete customer satisfaction.</p>
          </div>
          <div className="icon-card">
            <FaThumbsUp className="service-icon" />
            <h3>Skilled Technicians</h3>
            <p>Our technicians are experienced in fridge repairs.</p>
          </div>
        </div>
      </div><div className="door-section">
  <h2 className="section-title">We Can Perform Various Types of Work for Fridge Service</h2>
  <div className="door-container">
    {/* Single Door Section */}
    <div className="door-card">
      <img
        src={singledoor}
        alt="Single Door"
        className="door-image"
      />
      <div className="door-content">
        <h3>Single Door Refrigerator</h3>
        <p>Our repair services include checking and fixing compressor problems, sealing leaks, and inspecting the electrical components. If your refrigerator isn't cooling properly, our team will thoroughly assess the system, fix the root cause, and restore optimal functionality.</p>
      </div>
    </div>

    {/* Double Door Section */}
    <div className="door-card">
      <img
        src={doubledoor}
        alt="Double Door"
        className="door-image"
      />
      <div className="door-content">
        <h3>Double Door Refrigerator</h3>
        <p>Our professional maintenance services for double-door refrigerators ensure that your appliance operates at its peak efficiency. Regular servicing can prevent potential issues, such as cooling problems, freezer malfunctions, and water leakage, all of which can be costly to repair if left unchecked.</p>
      </div>
    </div>
  </div>
</div>

      {/* Testimonials Section */}
      <div className="testimonials-section">
        <h2>What Our Customers Say</h2>
        <div className="testimonials-carousel">
          <div className="testimonial">
            <p>"Outstanding service! My fridge was back to normal quickly."</p>
            <span>- Arun, Chennai</span>
          </div>
          <div className="testimonial">
            <p>"Highly recommend Chennai Home Appliance Care!"</p>
            <span>- Meena, Chennai</span>
          </div>
          <div className="testimonial">
            <p>"Quick and affordable fridge repair. Very satisfied!"</p>
            <span>- Lakshmi, Chennai</span>
          </div>
          <div className="testimonial">
            <p>"The technician fixed my fridge issue on the first visit!"</p>
            <span>- Ravi, Chennai</span>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-item" onClick={() => toggleFAQ(1)}>
          <h3>How long does a fridge repair usually take?</h3>
          {openFAQ === 1 && <p>Most repairs take between 1-2 hours, depending on the complexity of the issue.</p>}
        </div>
        <div className="faq-item" onClick={() => toggleFAQ(2)}>
          <h3>Do you provide a warranty on repairs?</h3>
          {openFAQ === 2 && <p>Yes, we provide a 30-day warranty on all repairs to ensure customer satisfaction.</p>}
        </div>
        <div className="faq-item" onClick={() => toggleFAQ(3)}>
          <h3>What types of fridges do you service?</h3>
          {openFAQ === 3 && <p>We service all types of fridges from all major brands.</p>}
        </div>
        <div className="faq-item" onClick={() => toggleFAQ(4)}>
          <h3>How do I book a repair service?</h3>
          {openFAQ === 4 && <p>You can book a repair service by calling us directly or filling out our online booking form.</p>}
        </div>
      </div>
      <div className="countdown-section" ref={sectionRef}>
  <h2>Our Achievements</h2>
  <div className="countdown-grid">
    {/* Counter 1 */}
    <div className="counter">
      <h3>Years of Experience</h3>
      {inView && (
        <CountUp start={0} end={15} duration={2} suffix="+" className="count-number" />
      )}
    </div>

    {/* Counter 2 */}
    <div className="counter">
      <h3>Customers Satisfied</h3>
      {inView && (
        <CountUp start={0} end={500} duration={2.5} suffix="+" className="count-number" />
      )}
    </div>

    {/* Counter 3 */}
    <div className="counter">
      <h3>Projects Completed</h3>
      {inView && (
        <CountUp start={0} end={200} duration={3} suffix="+" className="count-number" />
      )}
    </div>

    {/* Counter 4 */}
    <div className="counter">
      <h3>Awards Won</h3>
      {inView && (
        <CountUp start={0} end={15} duration={2} suffix="+" className="count-number" />
      )}
    </div>
  </div>
</div>

 
<div className="cta-section">
<h2>Need Help with Your Fridge?</h2>
<p>Contact us today to schedule a service!</p>
<button className="cta-button" onClick={() => (window.location.href = 'tel:+918270096596')}>
  Call Us: 82700 96596
</button>
</div>

    </>
  );
}

export default FridgeService;
